// Generated by Melange


function format(duration) {
  const minutes = Math.floor(duration / 60.0);
  const seconds = Math.floor(duration - minutes * 60.0);
  return String(minutes) + (":" + String(seconds).padStart(2, "0"));
}

export {
  format,
}
/* No side effect */
